module.exports = __webpack_public_path__ + "media/images/pix-4605834891d09a1429403d4b50042df0.png";